'use strict';

window.addEventListener('hashchange', () => {
  if (window.location.hash === '#menu') {
    document.body.classList.add('page__body--with-menu');
  } else {
    document.body.classList.remove('page__body--with-menu');
  }
});

document.getElementById('form-bottom').addEventListener('submit', (event) => {
  event.preventDefault();
  document.getElementById('form-bottom').reset();
});
